import { createSlice } from "@reduxjs/toolkit"; 
import { authInitState, authSilceName } from ".";
import { changePasswordAction } from "./changePasswordAction";
import { loginAction } from "./loginAction";
import { logoutAction } from "./logoutAction";

const authSlice = createSlice({
  name: `${authSilceName}`,
  initialState: authInitState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginAction.fulfilled, (state, action) => {
        state.accessToken = action.payload.response.token;
        state.userInfo = action.payload.response.userInfo;
        state.authenticated = true;
      })
      .addCase(logoutAction.fulfilled, (state) => {
        state.accessToken = null;
        state.userInfo = null;
        state.authenticated = false;
      })
      .addCase(changePasswordAction.fulfilled, (state, action) => {
        if (action.payload?.status === 200 && state.userInfo) {
          state.userInfo.changePasswordRequired = false;
        }
      });
  },
});
const authReducer = authSlice.reducer;

export default authReducer;
